import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { getDRE } from './dreActions';

const dataInput = data => {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
};

const filtrosIniciais = () => {
    const hoje = new Date();

    return {
        dataInicial: dataInput(
            new Date(hoje.getFullYear(), hoje.getMonth(), 1)
        ),
        dataFinal: dataInput(
            new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)
        ),
        regime: 'COMPETENCIA'
    };
};

const moeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const secoes = [
    { tipo: 'RECEITA', titulo: 'Receita Bruta' },
    { tipo: 'DEDUCAO', titulo: '(-) Deduções' },
    { total: 'receita_liquida', titulo: '= Receita Líquida' },
    { tipo: 'CUSTO', titulo: '(-) Custos' },
    { total: 'resultado_bruto', titulo: '= Resultado Bruto' },
    { tipo: 'DESPESA', titulo: '(-) Despesas' },
    { tipo: 'IMPOSTO', titulo: '(-) Impostos' },
    { total: 'resultado', titulo: '= Resultado do Período', final: true }
];

const DRE = props => {
    const [filtros, setFiltros] = useState(filtrosIniciais);

    useEffect(() => {
        props.getDRE(filtros);
    }, []);

    const subtotalTipo = tipo => (props.itens || [])
        .filter(item => item.tipo === tipo)
        .reduce((total, item) => total + Number(item.valor), 0);

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <Grid cols='12 6 3 3'>
                            <div className='form-group'>
                                <label>Período inicial</label>
                                <input
                                    type='date'
                                    className='form-control'
                                    value={filtros.dataInicial}
                                    onChange={evento => setFiltros({
                                        ...filtros,
                                        dataInicial: evento.target.value
                                    })}
                                />
                            </div>
                        </Grid>
                        <Grid cols='12 6 3 3'>
                            <div className='form-group'>
                                <label>Período final</label>
                                <input
                                    type='date'
                                    className='form-control'
                                    value={filtros.dataFinal}
                                    onChange={evento => setFiltros({
                                        ...filtros,
                                        dataFinal: evento.target.value
                                    })}
                                />
                            </div>
                        </Grid>
                        <Grid cols='12 6 3 3'>
                            <button
                                type='button'
                                className='btn btn-primary'
                                style={{
                                    width: '100%',
                                    marginTop: 29
                                }}
                                onClick={() => props.getDRE(filtros)}
                            >
                                <i
                                    className='fas fa-sync-alt'
                                    style={{ marginRight: 7 }}
                                />
                                Atualizar DRE
                            </button>
                        </Grid>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <div className='table-responsive'>
                        <table className='table table-bordered table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>
                                        Conta
                                    </th>
                                    <th
                                        style={{
                                            width: 190,
                                            textAlign: 'right',
                                            paddingRight: 14
                                        }}
                                    >
                                        Valor
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {secoes.map(secao => {
                                    if (secao.total) {
                                        const valor =
                                            Number(props.resumo[secao.total]) || 0;

                                        return (
                                            <tr
                                                key={secao.total}
                                                style={{
                                                    fontWeight: 700,
                                                    fontSize: secao.final
                                                        ? 17
                                                        : 15,
                                                    background: secao.final
                                                        ? '#eaf4ff'
                                                        : '#f3f7fb'
                                                }}
                                            >
                                                <td>{secao.titulo}</td>
                                                <td style={{
                                                    textAlign: 'right',
                                                    paddingRight: 14,
                                                    color: valor < 0
                                                        ? '#b91c1c'
                                                        : '#14532d'
                                                }}>
                                                    {moeda(valor)}
                                                </td>
                                            </tr>
                                        );
                                    }

                                    const itens = (props.itens || [])
                                        .filter(item =>
                                            item.tipo === secao.tipo);

                                    return (
                                        <React.Fragment key={secao.tipo}>
                                            <tr style={{
                                                background: '#eef2f7',
                                                fontWeight: 700
                                            }}>
                                                <td>{secao.titulo}</td>
                                                <td style={{
                                                    textAlign: 'right',
                                                    paddingRight: 14
                                                }}>
                                                    {moeda(subtotalTipo(secao.tipo))}
                                                </td>
                                            </tr>
                                            {itens.map(item => (
                                                <tr key={item.id}>
                                                    <td style={{ paddingLeft: 28 }}>
                                                        {item.codigo} - {item.nome}
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        paddingRight: 14
                                                    }}>
                                                        {moeda(item.valor)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </ContentCardBody>
            </ContentCard>
        </Content>
    );
};

const mapStateToProps = state => ({
    aguardando: state.dre.aguardando,
    itens: state.dre.itens,
    resumo: state.dre.resumo
});

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators({ getDRE }, dispatch)
)(DRE);
